import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import * as Icons from "lucide-react";
import { STATUS } from "@/mock/data";
import { useData } from "@/context/DataContext";
import { MatterModulos } from "@/components/MatterModulos";
import { HistoricoAsuntos, esHistorico } from "@/components/asuntos/HistoricoAsuntos";

const ESTADOS = [
  { id: "all", label: "Todos", status: null },
  { id: "attention", label: "Requiere atención", status: STATUS.ATTENTION },
  { id: "upcoming", label: "Próximamente", status: STATUS.UPCOMING },
  { id: "controlled", label: "Documentación al día", status: STATUS.CONTROLLED },
];

const PERSONAS = [
  { id: "all", label: "Todos" },
  { id: "me", label: "Yo" },
  { id: "family", label: "Familia" },
];

export default function Asuntos() {
  const navigate = useNavigate();
  const location = useLocation();
  const { matters: allMatters } = useData();

  const initialEstado = new URLSearchParams(location.search).get("estado");
  const [estado, setEstado] = useState(
    ESTADOS.some((e) => e.id === initialEstado) ? initialEstado : "all"
  );
  const [persona, setPersona] = useState("all");

  const base = allMatters.filter((m) => {
    if (persona === "me") return m.family_member_id === "fm-self";
    if (persona === "family") return m.family_member_id !== "fm-self";
    return true;
  });

  const activo = ESTADOS.find((e) => e.id === estado) || ESTADOS[0];
  const matters = activo.status ? base.filter((m) => m.status === activo.status) : base;

  return (
    <div className="space-y-5">
      <button
        data-testid="asuntos-back"
        onClick={() => navigate(-1)}
        className="inline-flex items-center gap-1.5 text-[#3A6B56] font-semibold text-base min-h-[44px]"
      >
        <Icons.ChevronLeft size={22} /> Volver
      </button>

      <header className="aldia-fade-up">
        <h1 className="font-heading text-2xl sm:text-3xl font-bold text-[#1C2421]">Tus asuntos</h1>
        <p className="text-base text-[#6E7A74] mt-1">
          Filtra por estado o por persona. Aquí tienes todo, incluida la documentación al día.
        </p>
      </header>

      {/* Filtro por estado */}
      <div className="flex flex-wrap gap-2" data-testid="asuntos-estado-filter">
        {ESTADOS.map((e) => (
          <button
            key={e.id}
            data-testid={`asuntos-estado-${e.id}`}
            onClick={() => setEstado(e.id)}
            className={`min-h-[44px] px-4 rounded-full font-semibold text-sm border transition-colors ${
              estado === e.id
                ? "bg-[#3A6B56] text-white border-[#3A6B56]"
                : "bg-white text-[#4A5550] border-[#E5DFD5] hover:border-[#3A6B56]"
            }`}
          >
            {e.label}
          </button>
        ))}
      </div>

      {/* Filtro por persona */}
      <div className="flex gap-1.5 bg-[#F2EDE4] p-1.5 rounded-2xl" data-testid="asuntos-persona-filter">
        {PERSONAS.map((p) => (
          <button
            key={p.id}
            data-testid={`asuntos-persona-${p.id}`}
            onClick={() => setPersona(p.id)}
            className={`flex-1 min-h-[44px] rounded-xl font-semibold text-base transition-colors ${
              persona === p.id ? "bg-white text-[#1C2421] shadow-sm" : "text-[#6E7A74] hover:text-[#1C2421]"
            }`}
          >
            {p.label}
          </button>
        ))}
      </div>

      <MatterModulos matters={matters.filter((m) => !esHistorico(m))} emptyText="No hay asuntos activos para este filtro." />
      {!activo.status && <HistoricoAsuntos matters={base.filter(esHistorico)} />}
    </div>
  );
}
